<template>
  <div class="animated fadeIn container-fluid">
    <b-row>
      <b-col md="4" class="row-col">
        <div class="example-avatar">
          <div class="avatar-upload" v-show="!edit">
            <div class="text-center p-2">
              <label
                ><!-- <label for="avatar"> -->
                <img :src="pic ? pic : defaultAvatar" class="rounded-circle" />
              </label>
            </div>
            <div class="text-center p-2">
              <file-upload
                extensions="gif,jpg,jpeg,png,webp"
                accept="image/png,image/gif,image/jpeg,image/webp"
                :drop="true"
                name="avatar"
                class="btn btn-success"
                v-model="files"
                @input-filter="image_inputFilter"
                @input-file="check_inputFile"
                ref="upload"
              >
                {{ $t("menu.upload_avatar") }}
              </file-upload>
            </div>
            <div v-if="pic_err" class="text-center err-msg">
              {{ $t("other.format_supported") }} : png, gif, jpg
            </div>
          </div>

          <div class="avatar-edit" v-show="files.length && edit">
            <vue-cropper
              v-if="files.length && edit"
              ref="cropper"
              :src="files[0].url"
              :info="true"
              :aspectRatio="1"
              :fixedBox="true"
              :centerBox="true"
              :canScale="true"
              alt="Source Image"
            >
            </vue-cropper>
            <div class="text-center p-4">
              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="$refs.upload.clear"
              >
                {{ $t("menu.cancel") }}
              </button>
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="avatar_editSave"
                :disabled="btn_avatar"
              >
                {{ $t("menu.save_changes") }}
              </button>
            </div>
          </div>
        </div>
      </b-col>

      <b-col md="7" xl="5" class="row-col">
        <h4 v-text="$t('menu.user_profile')"></h4>
        <p class="text-muted" v-text="$t('other.input_required')">
          * 為必填項目
        </p>
        <b-form v-if="autoGetData">
          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text
                ><i class="icon-user"></i
                >{{ $t("menu.first_name") }} *</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              aria-describedby="inputFeedback_fn"
              v-model.trim="first_name"
              :placeholder="$t('menu.first_name')"
              :state="nameState(first_name)"
            />
            <b-form-invalid-feedback id="inputFeedback_fn">
              Enter at least 1 letters
            </b-form-invalid-feedback>
          </b-input-group>

          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text
                ><i class="icon-user"></i
                >{{ $t("menu.last_name") }} *</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              aria-describedby="inputFeedback_ln"
              v-model.trim="last_name"
              :placeholder="$t('menu.last_name')"
              :state="nameState(last_name)"
            />
            <b-form-invalid-feedback id="inputFeedback_ln">
              Enter at least 1 letters
            </b-form-invalid-feedback>
          </b-input-group>

          <!-- this is a form text block (formerly known as help block) -->
          <div role="group" class="mb-3">
            <b-form-text v-if="first_name || last_name">
              Hi, {{ first_name }} {{ last_name }}
              <span v-if="first_name && last_name"
                ><i class="fa fa-check-circle"></i
              ></span>
            </b-form-text>
          </div>

          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text
                ><i class="cui-envelope-closed"></i
                >{{ $t("menu.email") }}</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="email"
              :disabled="true"
            />
          </b-input-group>

          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text
                ><i class="icon-phone"></i
                >{{ $t("menu.phone") }}</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="phone"
              :placeholder="$t('other.phone_placeholder')"
            />
          </b-input-group>

          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text
                ><i class="icon-location-pin"></i
                >{{ $t("menu.address") }}</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="address"
            />
          </b-input-group>

          <b-input-group class="mb-3">
            <b-input-group-prepend>
              <b-input-group-text
                ><i class="icon-shield"></i
                >{{ $t("menu.company_job") }}</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="company"
              :placeholder="$t('other.company_placeholder')"
            />
          </b-input-group>

          <!-- 送出請求後的訊息 -->
          <div v-if="checkState.failed" class="err-msg">
            {{ $t("other.update_failed") }}
          </div>
          <div v-if="checkState.succeeded" class="success-msg">
            {{ $t("other.update_succeeded") }}
          </div>
          <br />
          <b-button
            variant="success"
            class="px-4"
            v-text="$t('menu.save_changes')"
            @click="setData"
            :disabled="checkSetDataBTN"
            >儲存變更</b-button
          >
        </b-form>
      </b-col>
    </b-row>

    <hr />

    <b-row>
      <b-col md="4" class="row-col"> </b-col>
      <b-col md="7" xl="5" class="row-col">
        <h4>
          {{ $t("menu.reset_password") }}
          <i :class="showPasswordBtn" @click="switchShowPassword"></i>
        </h4>
        <b-form>
          <p class="text-muted" v-text="$t('other.enter_the_password')">
            Enter the password
          </p>
          <b-input-group class="mb-3">
            <b-input-group-prepend
              ><b-input-group-text>
                <i class="icon-lock"></i> </b-input-group-text
            ></b-input-group-prepend>
            <b-form-input
              :type="p_show"
              class="form-control"
              v-model="password[2]"
              :placeholder="$t('menu.password')"
              :state="passwordState(2)"
            />
          </b-input-group>

          <p class="text-muted" v-text="$t('other.enter_the_new_password')">
            Enter the new password
          </p>
          <b-input-group class="mb-3">
            <b-input-group-prepend
              ><b-input-group-text>
                <i class="icon-lock"></i> </b-input-group-text
            ></b-input-group-prepend>
            <b-form-input
              :type="p_show"
              class="form-control"
              v-model="password[0]"
              :placeholder="$t('other.enter_the_new_password')"
              :state="passwordState(0)"
            />
          </b-input-group>

          <b-input-group class="mb-4">
            <b-input-group-prepend
              ><b-input-group-text>
                <i class="icon-lock"></i> </b-input-group-text
            ></b-input-group-prepend>
            <b-form-input
              :type="p_show"
              class="form-control"
              v-model="password[1]"
              :placeholder="$t('other.enter_the_new_password_again')"
              :state="passwordState(1)"
            />
          </b-input-group>

          <div class="err-msg">* {{ $t("other.password_info_format") }}</div>
          <div v-if="p_err.old_required" class="err-msg">
            * {{ $t("other.password_info_old") }}
          </div>
          <div v-if="p_err.old_new_same" class="err-msg">
            * {{ $t("other.password_info_old_compare") }}
          </div>
          <div v-if="p_err.new_not_same" class="err-msg">
            * {{ $t("other.password_info_new_compare") }}
          </div>

          <!-- 送出請求後的訊息 -->
          <div v-if="p_err.reset_failed" class="err-msg">
            {{ $t("other.set_password_failed") }}
          </div>
          <div v-if="p_err.reset_succeeded" class="success-msg">
            {{ $t("other.set_password_succeeded") }}
          </div>
          <br />
          <b-button
            variant="success"
            class="px-4"
            v-text="$t('menu.reset_password')"
            :disabled="disabledResetBtn || btn_setPassword"
            @click="resetPassword"
            >重設密碼</b-button
          >
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import FileUpload from "vue-upload-component";
import { mapState } from "vuex";

export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      // avatar
      files: [],
      edit: false,
      pic_err: false,
      pic: undefined,

      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      address: "",
      company: "",
      checkState: {
        failed: false,
        succeeded: false,
      },

      // password
      password: ["", "", ""], // new, new 2, old
      p_show: "password",
      p_err: {
        old_required: false, // 必須先輸入舊密碼
        old_new_same: false, // 新舊密碼相同
        new_format_err: false, // 新密碼格式不合
        new_not_same: false, // 新密碼兩次輸入不一樣
        reset_failed: false, // 重設密碼失敗
        reset_succeeded: true, // 重設密碼成功
      },

      // button
      btn_setData: false, // 送出使用者資料按鈕
      btn_avatar: false,
      btn_setPassword: false, // 送出重設密碼按鈕
      btn_showPassword: false, // 顯示密碼
    };
  },
  computed: {
    ...mapState({
      default_avatar: (state) => state.user.default_avatar,
    }),

    defaultAvatar() {
      return this.default_avatar;
    },
    checkSetDataBTN() {
      if (!this.nameState(this.first_name)) return true; // 名字檢核沒過
      if (!this.nameState(this.last_name)) return true; // 姓氏檢核沒過

      return this.btn_setData;
    },
    showPasswordBtn() {
      return this.$tools.input.showPasswordBtn(this.btn_showPassword).class;
    },
    disabledResetBtn() {
      if (this.password[2].length == 0) return true; // 沒有輸入舊密碼就 disable
      if (this.password[0].length == 0) return true; // 沒有輸入新密碼就 disable
      if (this.password[1].length == 0) return true; // 沒有輸入新密碼2就 disable

      return (
        this.p_err.old_new_same ||
        this.p_err.new_format_err ||
        this.p_err.new_not_same
      ); // 有錯誤就 disable
    },
    // 自動更新 store 裡面有變動的參數
    autoGetData() {
      this.pic = this.$store.state.user.pic;

      this.first_name = this.$store.state.user.first_name;
      this.last_name = this.$store.state.user.last_name;
      this.email = this.$store.state.user.email;
      this.phone = this.$store.state.user.phone;
      this.address = this.$store.state.user.address;
      this.company = this.$store.state.user.company;

      //console.log('autoGetData');
      return true;
    },
  },
  methods: {
    // 使用者資料撈取
    getDataFromAPI() {
      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Profile"),
      };
      this.$http(options)
        .then((res) => {
          // console.log('取得使用者資料：Profile');
          // console.log(res.data);
          this.$store.commit("user/updateData", res.data);

          //this.getData();
        })
        .catch((err) => {});
    },
    // 使用者資料上傳並更新
    setData() {
      this.btn_setData = true;
      this.checkState.succeeded = false;
      this.checkState.failed = false;

      const options = {
        method: "PUT",
        url: this.$config.getAPI_URL("Profile"),
        data: {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone: this.phone,
          address: this.address,
          company: this.company,
        },
      };
      this.$http(options)
        .then((res) => {
          this.getDataFromAPI();
          this.checkState.succeeded = true;
          this.checkState.failed = false;
          this.btn_setData = false;
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.user_profile")
          );
        })
        .catch((err) => {
          console.log("更新使用者資料：err");
          this.checkState.succeeded = false;
          this.checkState.failed = true;
          this.btn_setData = false;
          this.$toastr.e(
            this.$t("other.update_failed"),
            this.$t("menu.user_profile")
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "user",
          action: "update info",
          querySettings: {
            "user name": this.first_name + " " + this.last_name,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },
    // 修改密碼
    resetPassword() {
      this.btn_setPassword = true;
      const options = {
        method: "PUT",
        url: this.$config.getAPI_URL("Reset_Password"),
        data: {
          old_passwd: this.password[2],
          new_passwd: this.password[0],
        },
      };
      this.$http(options)
        .then((res) => {
          // console.log('修改密碼成功：');
          // console.log(res);
          this.p_err.reset_succeeded = true;
          this.p_err.reset_failed = false;
          this.btn_setPassword = false;
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.password")
          );
        })
        .catch((err) => {
          // console.log('修改密碼失敗：err');
          // console.log(err);
          this.p_err.reset_succeeded = false;
          this.p_err.reset_failed = true;
          this.btn_setPassword = false;
          this.$toastr.e(
            this.$t("other.update_failed"),
            this.$t("menu.password")
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "user",
          action: "reset password",
          querySettings: {
            "user name":
              this.$store.state.user.first_name +
              " " +
              this.$store.state.user.last_name,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    // 檢查機制
    nameState(name) {
      return this.$tools.input.checkName(name, 1, false);
    },
    passwordState(idx) {
      this.p_err.reset_succeeded = false;
      this.p_err.reset_failed = false;
      return this.$tools.input.checkPasswordList(
        idx,
        this.password,
        this.p_err,
        true
      );
    },
    switchShowPassword() {
      this.btn_showPassword = !this.btn_showPassword;
      this.p_show = this.$tools.input.showPasswordBtn(
        this.btn_showPassword
      ).inputType;
    },

    // upload methods
    // 確認上傳頭像
    avatar_editSave() {
      this.btn_avatar = true;
      let _oldFile = this.files[0];
      let _fileOptions = {
        maxWidth: 300,
        minWidth: 300,
      };
      let _binStr = atob(
        this.$refs.cropper
          .getCroppedCanvas(_fileOptions)
          .toDataURL(_oldFile.type)
          .split(",")[1]
      );
      let _arr = new Uint8Array(_binStr.length);
      for (let i = 0; i < _binStr.length; i++) {
        _arr[i] = _binStr.charCodeAt(i);
      }
      let _file = new File([_arr], _oldFile.name, { type: _oldFile.type });
      // console.log(_file.type);

      this.$store
        .dispatch("user/uploadAvatar", _file)
        .then((res) => {
          // console.log('上傳成功：');
          // console.log(res);
          this.pic_err = false;
          this.btn_avatar = false;
          this.edit = false;
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.upload_avatar")
          );
        })
        .catch((err) => {
          // console.log('上傳失敗：err');
          // console.log(err);
          this.pic_err = true;
          this.btn_avatar = false;
          this.edit = false;
          this.$toastr.e(
            this.$t("other.update_failed"),
            this.$t("menu.upload_avatar")
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "user",
          action: "update avatar",
          querySettings: {
            "user name":
              this.$store.state.user.first_name +
              " " +
              this.$store.state.user.last_name,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    check_inputFile(newFile, oldFile, prevent) {
      this.$tools.input.check_inputFile(newFile, oldFile, prevent, this);
    },
    image_inputFilter(newFile, oldFile, prevent) {
      this.$tools.input.image_inputFilter(newFile, oldFile, prevent, this);
    },
  },
};
</script>





<style lang="scss" scoped>
// image
$profile-image-size: 150px;

.example-avatar .avatar-upload .rounded-circle {
  width: $profile-image-size;
  height: $profile-image-size;
}
.example-avatar .text-center .btn {
  margin: 0 0.5rem;
}
.example-avatar .avatar-edit-image,
.example-avatar .avatar-edit-image img {
  max-width: 100%;
}
</style>

